var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "roll" } }, [
    _c("div", { staticClass: "header flex flex-ver" }, [
      _c(
        "div",
        {
          class: { active: _vm.category == 0 },
          on: {
            click: function ($event) {
              return _vm.switchtab(0)
            },
          },
        },
        [_c("span", [_vm._v("全部")])]
      ),
      _c(
        "div",
        {
          class: { active: _vm.category == 1 },
          on: {
            click: function ($event) {
              return _vm.switchtab(1)
            },
          },
        },
        [_c("span", [_vm._v("官方")])]
      ),
      _c(
        "div",
        {
          class: { active: _vm.category == 2 },
          on: {
            click: function ($event) {
              return _vm.switchtab(2)
            },
          },
        },
        [_c("span", [_vm._v("主播")])]
      ),
      _c(
        "div",
        {
          class: { active: _vm.category == 3 },
          on: {
            click: function ($event) {
              return _vm.switchtab(3)
            },
          },
        },
        [_c("span", [_vm._v("自建")])]
      ),
      _c(
        "div",
        {
          class: { active: _vm.category == 4 },
          on: {
            click: function ($event) {
              return _vm.switchtab(4)
            },
          },
        },
        [_c("span", [_vm._v("我参与的")])]
      ),
      _c(
        "div",
        {
          class: { active: _vm.category == 5 },
          on: {
            click: function ($event) {
              return _vm.switchtab(5)
            },
          },
        },
        [_c("span", [_vm._v("我创建的")])]
      ),
      _c(
        "div",
        {
          class: { active: _vm.category == 6 },
          on: {
            click: function ($event) {
              return _vm.switchtab(6)
            },
          },
        },
        [_c("span", [_vm._v("结束")])]
      ),
      _c("div", { staticClass: "create-btn", on: { click: _vm.goCreate } }, [
        _c("span", [_vm._v("创建ROLL房")]),
      ]),
    ]),
    _c(
      "ul",
      { staticClass: "roll-room-list" },
      _vm._l(_vm.rollData, function (item) {
        return _c(
          "li",
          {
            staticClass: "roll",
            on: {
              click: function ($event) {
                return _vm.$router.push({
                  name: "rollDetail",
                  params: { id: item.id },
                })
              },
            },
          },
          [_c("c-RoomItem", { attrs: { room: item } })],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }